import { useEffect } from 'react';
import { useSelector } from 'react-redux';
/**
 * This helper is used if the default value for a form is
 * loaded asynchronously, and might not be available in redux
 * when the form is first loaded.
 *
 * It watches the redux store for changes, and updates the state
 * when the state changes.
 */
export default function useAsyncDefault(field, setValues, selector) {
  const fieldValue = useSelector(selector);

  useEffect(() => {
    setValues((values) => ({ ...values, [field]: fieldValue }));
  }, [fieldValue, field, setValues]);
}
